import userInfo from "./userInfo";
import settingData from './settingData';
import { combineReducers } from "redux";

export default combineReducers({ userInfo, settingData });